import Vue from 'vue'
import VueVirtualScroller from 'vue-virtual-scroller'

Vue.use(VueVirtualScroller)


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/virtualScroller.js